import React from 'react';

const CustomModal = ({
                         show,
                         title,
                         message,
                         type,
                         onConfirm,
                         onHide,
                         confirmText = 'Confirmar',
                         cancelText = 'Cancelar',
                         showCancel = true,
                         confirmVariant = 'primary'
                     }) => {
    if (!show) return null;

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <i className="bi bi-check-circle-fill text-success fs-4"></i>;
            case 'error':
                return <i className="bi bi-x-circle-fill text-danger fs-4"></i>;
            case 'warning':
                return <i className="bi bi-exclamation-triangle-fill text-warning fs-4"></i>;
            case 'confirm':
                return <i className="bi bi-question-circle-fill text-primary fs-4"></i>;
            case 'info':
                return <i className="bi bi-info-circle-fill text-info fs-4"></i>;
            default:
                return <i className="bi bi-info-circle-fill text-info fs-4"></i>;
        }
    };

    const getConfirmButtonClass = () => {
        switch (confirmVariant) {
            case 'danger':
                return 'btn-danger';
            case 'success':
                return 'btn-success';
            case 'warning':
                return 'btn-warning';
            case 'info':
                return 'btn-info';
            default:
                return 'btn-primary';
        }
    };

    const getHeaderClass = () => {
        switch (type) {
            case 'success':
                return 'text-success';
            case 'error':
                return 'text-danger';
            case 'warning':
                return 'text-warning';
            case 'confirm':
                return 'text-primary';
            case 'info':
                return 'text-info';
            default:
                return 'text-info';
        }
    };

    const getModalSize = () => {
        // Para mensajes largos de confirmación de eliminación
        if (type === 'confirm' && message.length > 100) {
            return 'modal-dialog modal-dialog-centered';
        }
        return 'modal-dialog modal-dialog-centered';
    };

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(2px)' }}>
            <div className={getModalSize()}>
                <div className="modal-content border-0 shadow-lg rounded-3">
                    {/* Header con icono profesional */}
                    <div className="modal-header border-0 pb-0">
                        <div className="d-flex align-items-center">
                            <div className="me-3">
                                {getIcon()}
                            </div>
                            <div>
                                <h5 className={`modal-title fw-bold mb-0 ${getHeaderClass()}`}>
                                    {title}
                                </h5>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onHide}
                            aria-label="Cerrar"
                        ></button>
                    </div>

                    {/* Body del modal */}
                    <div className="modal-body py-4">
                        <div className="d-flex">
                            <div className="flex-shrink-0 me-3" style={{ marginTop: '2px' }}>
                                <i className="bi bi-chat-left-text text-muted"></i>
                            </div>
                            <div className="flex-grow-1">
                                <p className="mb-0" style={{ whiteSpace: 'pre-line', lineHeight: '1.5' }}>
                                    {message}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Footer con botones profesionales */}
                    <div className="modal-footer border-0 pt-0">
                        {showCancel && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary rounded-pill px-4 d-flex align-items-center gap-2"
                                onClick={onHide}
                            >
                                <i className="bi bi-x-circle"></i>
                                {cancelText}
                            </button>
                        )}
                        <button
                            type="button"
                            className={`btn ${getConfirmButtonClass()} rounded-pill px-4 fw-semibold d-flex align-items-center gap-2`}
                            onClick={onConfirm}
                        >
                            {confirmVariant === 'danger' ? (
                                <i className="bi bi-trash"></i>
                            ) : confirmVariant === 'success' ? (
                                <i className="bi bi-check-lg"></i>
                            ) : (
                                <i className="bi bi-check-lg"></i>
                            )}
                            {confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomModal;